import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideImages } from '../data/insideImages';
import { Ornament } from './Ornament';
const seeItems = ['See the positions.', 'See the movement sequences.', 'See the progressions.', 'See the corrections.'];
export function InsideCarousel() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const total = insideImages.length;
  const go = (step: number) => {
    setState(([current]) => [(current + step + total) % total, step]);
  };
  const image = insideImages[index];
  const navClasses = 'absolute top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-primary-strong text-primary-foreground shadow-card transition-colors duration-150 hover:bg-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-subtle';
  return <section id="inside" className="border-y border-primary/10 bg-surface-subtle px-4 py-20 sm:py-28" data-id="element-200" data-mp="2mu29ht1amrw1">
      <div className="mx-auto max-w-5xl" data-id="element-201" data-mp="2rsn7rmwzj1hu">
        <div className="text-center" data-id="element-202" data-mp="2wrge8vduts8i">
          <h2 className="mx-auto max-w-3xl text-3xl font-semibold uppercase leading-tight tracking-wide text-foreground sm:text-4xl" data-id="element-203" data-mp="2wqf2eop0l1pq">
            See Inside Barre Instructor Ready
          </h2>
          <Ornament className="mt-5" data-id="element-204" data-mp="35qv0fimzngn7" />
          <p className="mt-4 text-base text-muted-foreground" data-id="element-205" data-mp="35psape1ejk8v">
            Real pages from the 100% visual core teaching system.
          </p>
          <ul className="mx-auto mt-5 flex max-w-2xl flex-wrap justify-center gap-x-4 gap-y-1 text-sm font-semibold text-primary-strong" data-id="element-206" data-mp="3fhfxh1n0kd40">
            {seeItems.map(item => <li key={item} data-id="element-207" data-mp="3oinvdilmbbxk">{item}</li>)}
          </ul>
          <p className="mt-2 text-sm text-muted-foreground" data-id="element-208" data-mp="3ogb5mj9mbx9y">
            See exactly how each class is structured before you teach it.
          </p>
        </div>

        <div className="relative mx-auto mt-12 max-w-xl" role="region" aria-roledescription="carousel" aria-label="Inside pages of the system" data-id="element-209" data-mp="1tg9bvxejpwz5">
          <div className="relative overflow-hidden rounded-2xl border border-primary/20 bg-surface p-3 shadow-card" data-id="element-210" data-mp="2362ngyeouc3e">
            <div className="relative aspect-[4/5] overflow-hidden rounded-xl bg-background" data-id="element-211" data-mp="1ycrdwpihrh7s">
              <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-212" data-mp="2d1vvq5ldjjfd">
                <motion.img key={image.src} src={image.src} alt={image.alt} custom={direction} initial={{
                opacity: 0,
                x: direction >= 0 ? 40 : -40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction >= 0 ? -40 : 40
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.2} onDragEnd={(_, info) => {
                if (info.offset.x < -60) go(1);
                if (info.offset.x > 60) go(-1);
              }} className="absolute inset-0 h-full w-full cursor-grab object-contain active:cursor-grabbing" draggable={false} data-id="element-213" data-mp="2832i8d637sf7" />
              </AnimatePresence>
            </div>
          </div>

          <button type="button" onClick={() => go(-1)} aria-label="Previous image" className={`${navClasses} left-0 -translate-x-1/2 sm:-translate-x-[130%]`} data-id="element-214" data-mp="2fpzl55k1gdiz">
            <ChevronLeftIcon size={20} aria-hidden="true" data-id="element-215" data-mp="2aoa7rj9cfnrq" />
          </button>
          <button type="button" onClick={() => go(1)} aria-label="Next image" className={`${navClasses} right-0 translate-x-1/2 sm:translate-x-[130%]`} data-id="element-216" data-mp="2aqd92zfy53br">
            <ChevronRightIcon size={20} aria-hidden="true" data-id="element-217" data-mp="3gbx289ctvt80" />
          </button>

          <div className="mt-6 flex justify-center gap-2" data-id="element-218" data-mp="3g9ue5uv8ka5x">
            {insideImages.map((item, dotIndex) => <button key={item.src} type="button" onClick={() => setState([dotIndex, dotIndex > index ? 1 : -1])} aria-label={`Show image ${dotIndex + 1}`} aria-current={dotIndex === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${dotIndex === index ? 'w-7 bg-primary' : 'w-2.5 bg-primary/25 hover:bg-primary/50'}`} data-id="element-219" data-mp="36dr4m3y2198y" data-mpi={dotIndex} />)}
          </div>
        </div>
      </div>
    </section>;
}